<div class="row-container end-content mr-10 mt-10" >
  <i
    class="icon-ic-close popup_close color-link pointCursor"
    [attr.id]="buildJustificationDialogId('btn-close')"
    (click)="cancel()"
  (keydown.enter)="cancel()"></i>
</div>
<div class="row-container center-content mb-20">
  <form [formGroup]="justificationForm">
    <div class="row-container center-content">
      <div><strong class="font-xl">Justification required</strong></div>
    </div>
    <p> {{description[0]}} <br>
      {{description[1]}}
    </p>
    <div class="flex-column">
      <mat-form-field>
        <mat-select
          formControlName="justificationCode"
          placeholder="Select pre-defined justification"
          panelClass="mat-select-panel selectionpanel"
          [attr.id]="buildJustificationDialogId('ddl-justification-code')"
          (valueChange)="getJustificationComment($event)">
          @for (data of masterData(); track data) {
            <mat-option [value]="data.Key">{{data.Key}}</mat-option>
          }
        </mat-select>
        @if (justificationForm.get('justificationCode').hasError('required')) {
          <mat-error>Justification is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <textarea
          placeholder="Please describe why this change was required *"
          matInput
          rows="10"
          maxlength="500"
          formControlName="justificationComment"
          [attr.id]="buildJustificationDialogId('fld-justification-comment')"
        #comment></textarea>
        <mat-hint align="end" class="font-s">{{comment.value.length}}/500</mat-hint>
        @if (justificationForm.get('justificationComment').hasError('required')) {
          <mat-error>Comment field cannot be empty</mat-error>
        }
        @if (justificationForm.get('justificationComment').hasError('minlength')) {
          <mat-error>Comment field must have more than 10 characters</mat-error>
        }
        @if (justificationForm.get('justificationComment').hasError('maxlength')) {
          <mat-error>Comment field cannot have more than 500 characters</mat-error>
        }
      </mat-form-field>

    </div>
    <div class="row-container space-between-content">
      <button
        mat-raised-button
        color="primary"
        class="button_content primary-hover w-p-100"
        [attr.id]="buildJustificationDialogId('btn-confirm')"
      (click)="confirm()">Confirm</button>
      <button
        mat-button
        class="mat-button button_content w-p-100"
        color="primary"
        [attr.id]="buildJustificationDialogId('btn-cancel')"
      (click)="cancel()">Cancel</button>
    </div>
  </form>
</div>
